export default __webpack_public_path__ + "static/media/1209.f8efea89.png";